import { FC } from 'react';
import { largeCurrencyFormat } from 'common/formats/formats';
import { GridDateProps } from 'common/types/scalarSpreadsheet';
import { GridDate, GridDateEditor } from 'components/FeaturedSpreadsheet/components';
import { CashFlowColumnAlias, CashFlowColumnValue } from './constants';
import EntityDataEditor from '../data-editors/EntityDataEditor';
import OwnershipDataEditor from '../data-editors/OwnershipDataEditor';
import SecurityDataEditor from '../data-editors/SecurityDataEditor';
import DateValueViewer from '../value-viewers/DateValueViewer';
import EntityValueViewer from '../value-viewers/EntityValueViewer';
import OwnershipValueViewer from '../value-viewers/OwnershipValueViewer';
import SecurityValueViewer from '../value-viewers/SecurityValueViewer';


// Define the column structure for cash flow transactions
export const getCashFlowColumns = (currency: string = 'USD') => [
  {
    alias: CashFlowColumnAlias.DATE_OF_TRANSACTION,
    value: CashFlowColumnValue.DATE_OF_TRANSACTION,
    gridType: 'gridDate',
    dbType: 'dbDate',
    isRequired: true,
    displayUndefined: true,
    gridDateComponent: GridDate as FC<GridDateProps>,
    dataEditor: (props: any) => <GridDateEditor {...props} />,
    valueViewer: (props: any) => <DateValueViewer {...props} />,
  },
  {
    alias: CashFlowColumnAlias.AMOUNT,
    value: CashFlowColumnValue.AMOUNT,
    gridType: 'number',
    dbType: 'string',
    format: largeCurrencyFormat,
    isRequired: true,
    displayUndefined: true,
  },
  {
    alias: CashFlowColumnAlias.CURRENCY,
    value: CashFlowColumnValue.CURRENCY,
    gridType: 'string',
    dbType: 'string',
    readOnly: true,
    defaultValue: currency,
    displayUndefined: true,
  },
  {
    alias: CashFlowColumnAlias.TRANSACTION_TYPE,
    value: CashFlowColumnValue.TRANSACTION_TYPE,
    gridType: 'string',
    dbType: 'string',
    isRequired: true,
    displayUndefined: true,
  },
  {
    alias: CashFlowColumnAlias.OWNER,
    value: CashFlowColumnValue.OWNER,
    gridType: 'string',
    dbType: 'string',
    isRequired: true,
    displayUndefined: true,
    valueViewer: (props: any) => <OwnershipValueViewer {...props} />,
    dataEditor: (props: any) => <OwnershipDataEditor {...props} />,
  },
  {
    alias: CashFlowColumnAlias.ENTITY,
    value: CashFlowColumnValue.ENTITY,
    gridType: 'string',
    dbType: 'string',
    isRequired: true,
    displayUndefined: true,
    valueViewer: (props: any) => <EntityValueViewer {...props} />,
    dataEditor: (props: any) => <EntityDataEditor {...props} />,
  },
  {
    alias: CashFlowColumnAlias.ALL_SECURITY,
    value: CashFlowColumnValue.ALL_SECURITY,
    gridType: 'string',
    dbType: 'string',
    isRequired: false,
    displayUndefined: true,
    valueViewer: (props: any) => <SecurityValueViewer {...props} />,
    dataEditor: (props: any) => <SecurityDataEditor {...props} />,
  },
];
